import { useCallback, useEffect, useMemo, useState } from 'react';
import { API } from '../api/api';

const REFRESH_MS = 10 * 60 * 1000;

// Leaderboard-listen (kun level, procent og XP) og brugerens egen plads. Fejl giver entries = null,
// så baren kan skjule pladsen.
export function useLeaderboard() {
  const [entries, setEntries] = useState(null);
  const reload = useCallback(() => API.getLeaderboard()
    .then((r) => setEntries(Array.isArray(r?.entries) ? r.entries : null))
    .catch(() => setEntries(null)), []);

  useEffect(() => {
    reload();
    const id = setInterval(reload, REFRESH_MS);
    return () => clearInterval(id);
  }, [reload]);

  const rank = useMemo(() => {
    const idx = (entries || []).findIndex((e) => e.me);
    return idx === -1 ? null : { rank: idx + 1, of: entries.length };
  }, [entries]);

  return { entries, rank, reload };
}
